<template>
  <header class="service-header">
    <div class="header-bg">
      <div class="bg-pattern" />
    </div>
    <div class="header-content">
      <router-link
        v-if="showBackLink"
        to="/"
        class="back-link"
      >
        <i class="fas fa-arrow-left" />
        Back to Home
      </router-link>
      <h1>{{ title }}</h1>
      <p>{{ subtitle }}</p>
    </div>
  </header>
</template>

<script>
export default {
  name: 'ServicePageHeader',
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    showBackLink: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.service-header {
  position: relative;
  padding: 8rem 1.5rem 4rem;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  overflow: hidden;
}

.header-bg {
  position: absolute;
  inset: 0;
  opacity: 0.1;
}

.bg-pattern {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle at 25% 25%, #10b981 2px, transparent 2px),
                    radial-gradient(circle at 75% 75%, #f59e0b 2px, transparent 2px);
  background-size: 50px 50px;
}

.header-content {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header-content h1 {
  font-size: clamp(1.75rem, 4vw, 2.5rem);
  font-weight: 800;
  color: white;
  margin-bottom: 1rem;
}

.header-content p {
  font-size: 1.125rem;
  color: #94a3b8;
  max-width: 600px;
  margin: 0 auto;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #94a3b8;
  text-decoration: none;
  margin-bottom: 1.5rem;
  font-size: 0.875rem;
  transition: color 0.2s;
}

.back-link:hover {
  color: #fff;
}

@media (max-width: 768px) {
  .service-header {
    padding: 6rem 1rem 3rem;
  }

  .header-content h1 {
    font-size: 1.75rem;
  }
}
</style>
